type TnewSessionResponse = {
  encryptedSessionKey?: string
  EncryptedSessionKey?: string
}

export function getTNEWOrigin() {
  if (env.dev && env.client) {
    return `https://${document.location.hostname}:8090`
  }

  return import.meta.env.ED_PUBLIC_TNEW_ORIGIN
}

export async function getEncryptedSessionKey() {
  const response = await fetch(`${await getTNEWOrigin()}/api/session/sessionkey/`, {
    credentials: "include",
    headers: {
      accept: "application/json",
    },
  })

  if (!response.ok) {
    throw new Error(`Unable to create TNEW session (${response.status})`)
  }

  const data = (await response.json()) as TnewSessionResponse
  const encryptedSessionKey = data.encryptedSessionKey ?? data.EncryptedSessionKey

  if (!encryptedSessionKey) {
    throw new Error("TNEW session response did not include an encrypted session key")
  }

  return encryptedSessionKey
}

export async function applyEncryptedSessionKey(encryptedSessionKey: string) {
  const response = await fetch(`${await getTNEWOrigin()}/api/session/sessionkey/`, {
    body: JSON.stringify({
      authenticatedMessage: encryptedSessionKey,
    }),
    credentials: "include",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    method: "POST",
  })

  if (!response.ok) {
    throw new Error(`Unable to apply TNEW session (${response.status})`)
  }
}
